import { Component, OnDestroy, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { toString as luceneToString, FieldExpression } from 'lucene';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor } from '@angular/common';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { OrderBy, OrderByDirection } from '../../../shared/utils/constant';
import { Batch } from '../../models/batch';
import { BatchesService } from '../../services/batches.service';
import { UNDERSCORE } from '../../../shared/components/utils/constants';
import { DimensionPipe } from '../../../shared/pipes/format-dimension.pipe';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';
import { DatacenterDefaultConfiguration } from '../../../shared/datacenter/datacenter-default-configuration';
import { DatacenterFilterType } from '../../../shared/models/datacenter-filters';

@Component({
	selector: 'copo-available-batches',
	templateUrl: './available-batches.component.html',
	styleUrl: './available-batches.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		TranslateModule,
		NgFor,
		RouterLink,

		MatButtonModule,
		MatIconModule,
		LoadingSpinnerComponent,
		DimensionPipe
	]
})
export class AvailableBatchesComponent implements OnDestroy, OnInit {
	batches?: Batch[];
	batchesSub?: Subscription;
	isLoading = true;
	constructor(
		private readonly batchesService: BatchesService,
		private readonly router: Router,
		private readonly route: ActivatedRoute,
		private readonly defaultConfiguration: DatacenterDefaultConfiguration,
	) {}

	ngOnInit() {
		this.batchesSub = this.batchesService.getBatches(
			[
				'daysInStock',
				'customerOrderNumber',
				'customerOrderItemNumber',
				'supplierOrderNumber',
				'supplierOrderItemNumber',
				'batchReference',
				'thickness',
				'width',
				'length',
				'steelgradeDescription',
				'customerArticleReference',
				'status',
				'id'
			],
			luceneToString(<FieldExpression> this.createStatusReadyForShipmentFilter('statusGroup')),
			1,
			10,
			new OrderBy('daysInStock', OrderByDirection.DESC),
			false
		).subscribe({
			next: res => {
				this.batches = res.results;
				this.isLoading = false;
			},
			error: (err: unknown) => {
				console.error('error requesting batches datacenter', err);
				this.isLoading = false;
			}
		});
	}

	createStatusReadyForShipmentFilter(field: string) {
		return {
			field,
			term: '2',
			quoted: true
		};
	}

	ngOnDestroy() {
		if (this.batchesSub) {
			this.batchesSub.unsubscribe();
		}
	}

	async viewDetails() {
		const defaultView = this.defaultConfiguration.getDefaultView('batch');
		const statusGroupFilter: DatacenterFilterType = {
			id: 'statusGroup',
			values: [
				{
					code: '2',
					translation: 'Available - Ready To Ship'
				}
			]
		};
		defaultView.filterState = [statusGroupFilter];
		await this.router.navigate(['/order-tracking/batch/datacenter'], {
			relativeTo: this.route,
			state: { view: defaultView }
		});
	}

	getOrderName(batch: Batch) {
		return batch.customerOrderNumber === ''
			? UNDERSCORE
			: `${ batch.customerOrderNumber }/${ batch.customerOrderItemNumber }`;
	}
}
